import { render, staticRenderFns } from "./HeadlineLabels.vue?vue&type=template&id=44d6d3fc"
import script from "./HeadlineLabels.vue?vue&type=script&lang=ts"
export * from "./HeadlineLabels.vue?vue&type=script&lang=ts"
import style0 from "./HeadlineLabels.vue?vue&type=style&index=0&id=44d6d3fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports